var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500", persistent: "" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "text--secondary" },
            [
              _c("v-icon", { staticClass: "mr-2" }, [
                _vm._v("mdi-alert-circle-outline"),
              ]),
              _vm._v(" Feature Currently Disabled "),
            ],
            1
          ),
          _c("v-card-text", { staticClass: "text--primary pt-4" }, [
            _c("p", [
              _vm._v(
                " This feature is currently disabled due to process changes at the Schaeffler IT Security Department. "
              ),
            ]),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v(" Azure Permissions must be requested via email at "),
              _c(
                "a",
                {
                  staticClass: "link",
                  attrs: { href: _vm.mailtoLink, target: "_blank" },
                },
                [_vm._v(" OR-HZA-AccessMgmt@schaeffler.com ")]
              ),
            ]),
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { color: "#006c27" },
                  on: { click: _vm.close },
                },
                [_vm._v(" OK ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }